import React, {useState, useEffect} from "react";
import {
    Typography,
    Button,
    makeStyles,
    Container,
} from "@material-ui/core";
import LaunchIcon from "@material-ui/icons/Launch";
import API from "../../../helpers/apiHelpers";
import {useLocation} from "react-router";
import {bootIntercom} from "../../../hooks/useIntercom";

interface Props {
    changeCount: (number: number) => void;
};

const useStyle = makeStyles(() => ({
    body: {
        paddingTop: 20,
    },
})
)
const SquareLink = ({changeCount}:Props) => {
    const classes = useStyle();
    const { state } = useLocation()
    console.log(state);
    const [linkToSquareOauth, setLinkToSquareOauth] = useState("");
    const [squareAuthButtonVisibility, setSquareAuthButtonVisibility] = useState(false);

    useEffect(() => {
        API.getSquareoauth()
            .then((res) => {
                    setSquareAuthButtonVisibility(false);
            })
            .catch(() => {
                API.getSquareOauthLink()
                    .then((link) => {
                        setLinkToSquareOauth(link);
                        setSquareAuthButtonVisibility(true);
                    });
            });
    }, []);

    const contactSupport = () => {
        bootIntercom().then(() => window.Intercom("show"));
    };

    return (
        <Container className={classes.body} disableGutters={true}>
            <Typography variant="h2" gutterBottom>
                Connect your Square Account
            </Typography>
            {
                squareAuthButtonVisibility ?
                <Button
                    onClick={() => {
                        window.open(linkToSquareOauth, "_blank");
                    }}
                    style={{display: "flex", alignItems: "center", justifyItems: "center"}}
                >
                    <Typography style={{paddingRight: 5}}>Connect square</Typography><LaunchIcon fontSize="small" color="primary"/>
                </Button>
                : <div>
                        <Typography style={{paddingRight: 5}}>{state?.message || "Your account is linked to Square. Please move to the next onboarding step."}</Typography>
                </div>
            }
            {state?.error ?
                <Button style={{marginTop: "20px", minWidth: "100px"}} variant="contained" color="secondary"
                        onClick={contactSupport}>Contact Support</Button>
                :
                <Button style={{marginTop: "20px", minWidth: "100px"}} variant="contained" color="secondary"
                        onClick={() => changeCount(1)}>Next</Button>
            }
        </Container>
    )
}
export default SquareLink
